<div class="gestion-zones-autorisees">
	<div class="ajout-zones-autorisees">
		<label>{{ 'GESTIONS_ZONES_AUTORISEES.LABEL_AJOUTER_ZONE' | translate }}</label>
		<div>
			<p-multiSelect
					[group]="true"
					[options]="groupesZonesDropdown()"
					[(ngModel)]="zonesSelectionneesIds"
					[emptyMessage]="'GESTIONS_ZONES_AUTORISEES.AUCUNE_ZONE_PRIVEE' | translate">
				<ng-template let-site pTemplate="group">
					<span>{{ site.label }}</span>
				</ng-template>
			</p-multiSelect>
			<p-button type="button"
					  label="{{ 'GESTIONS_ZONES_AUTORISEES.BTN_AJOUTER' | translate }}"
					  (onClick)="onClickAjouterZonesAutorisees()"/>
		</div>
	</div>
	<div class="chip-scroll-panel">
		<p-scrollPanel [style]="{ width: '100%', height: '75px' }">
			<div class="chip-zones-autorisees">
				@for (zone of _zonesAutorisees(); track zone.id) {
					<p-chip
							[label]="recupererLabelZone(zone)"
							[removable]="true"
							(onRemove)="onRemoveZoneAutorisee(zone)"/>
				}
			</div>
		</p-scrollPanel>
	</div>
</div>
